// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"304ca2fa","239":"e7d4d9a6","453":"999b4a03","455":"b5502fbb"}[chunkId] + ".chunk.js";
};